/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../../extendIcon';

const Battery = props => (
  <svg viewBox="0 0 128 128" width="1em" height="1em" {...props}>
    <path d="M3 35h115v8H3zM3 89h115v8H3z" />
    <path d="M3 39h8v56H3zM17 49h15v35H17zM110 39h8v56h-8z" />
    <path d="M116 51h10v29h-10z" />
  </svg>
);
export default extendIcon(Battery);
